import { render, staticRenderFns } from "./WebPages.vue?vue&type=template&id=02b08b7f&"
import script from "./WebPages.vue?vue&type=script&lang=js&"
export * from "./WebPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports